import React from "react";
import SubBanner from "./components/SubBanner";
import ContactSection from "./components/ContactSection";
import MapSection from "./components/MapSection";



function Contacts() {
  return (
    <>
      <SubBanner title="Contact Us" />
      <ContactSection />
      <MapSection />
      
     
    </>
  );
}

export default Contacts;